// extracted by mini-css-extract-plugin
export var MobileHeaderContainer = "WebsiteHeaderMenu-module--MobileHeaderContainer--77980";
export var MobileHeaderList = "WebsiteHeaderMenu-module--MobileHeaderList--1a53d";
export var WebsiteHeaderMenu = "WebsiteHeaderMenu-module--WebsiteHeaderMenu--2645e";
export var WebsiteHeaderMenuDesktop = "WebsiteHeaderMenu-module--WebsiteHeaderMenuDesktop--1add1";
export var WebsiteHeaderMenuMobile = "WebsiteHeaderMenu-module--WebsiteHeaderMenuMobile--87bef";